import React from 'react'
import './HomePlateform.css'
import Kpi from '../Kpi/Kpi'
import { useSelector, useDispatch } from 'react-redux'
import { loadStats } from '../../redux/statSlice'
import { loadArticles } from '../../redux/articleSlice'
import { loadBlogs } from '../../redux/blogSlice'
import { loadHirings } from '../../redux/hiringSlice'
import { loadHotels } from '../../redux/hotelSlice'
import { globals, ca_svg_flatten, icon_svg_room_flatten, icon_svg_room, le_cercle_svg_stream } from "../Globals/Globals";
import { CGUID} from "datasync-core";
import chambre_svg_rose from '../../Assets/img/icon/stats-svg-icons/Chambre_rose.svg'
import ca_svg_bleu from '../../Assets/img/icon/stats-svg-icons/CA_bleu.svg'

const HomeLocalKPI = (props) => {

// removed unused icon_svg_arrow_with_circle_stream

// Renderable React component version of the simplified CA icon

    const {statsItems, loadStats_result} = useSelector((state) => state.stats)
    const {loadArticles_result} = useSelector((state) => state.articles)
    const {loadBlogs_result} = useSelector((state) => state.blogs)
    const {loadHirings_result} = useSelector((state) => state.hirings)
    const {loadHotels_result} = useSelector((state) => state.hotels)
    const dispatch = useDispatch();

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true
    
        // If status is !loading, then fetch partners data from the API
        if (loadStats_result.status === 'idle'){
            dispatch(loadStats());
        }

        if (loadArticles_result.status === "idle"){
            dispatch(loadArticles());
        }

        if (loadBlogs_result.status === "idle"){
            dispatch(loadBlogs());
        }

        if (loadHirings_result.status === "idle"){
            dispatch(loadHirings());
        }

        if (loadHotels_result.status === "idle"){
            dispatch(loadHotels());
        }

        // Cleanup function
        return () => {
          isMounted = false
        }
      }, [loadStats_result, loadArticles_result, loadBlogs_result, loadHirings_result, loadHotels_result, dispatch]);
    
    const scrollRef = React.useRef(null);

    const kpiRendering = () => {    
        if (!((statsItems != null) && (statsItems.length > 0))){
            return (<img
              //id = "home-video"
              width="100%"
              height="100%"
              //src_old="https://i.vimeocdn.com/video/1449210825-79d671233bc3780a6c12c0ec819f752bbb44b392a88dd4ff734bf58794cec5ce-d?mw=3400&mh=1913&q=70"
              src={props.fallback_picture}
              alt="KPI fallback"
          />);
        }

        else return(
            <div className="kpi-board">
                <button
                    aria-label="scroll left"
                    className="kpi-arrow kpi-arrow-left"
                    onClick={() => { if (scrollRef.current) scrollRef.current.scrollBy({ left: -200, behavior: 'smooth' }); }}
                >
                    ‹
                </button>

                <div className="kpi-scroll" ref={scrollRef}>
                    
              {globals.parameters.debugging_svg &&
              <Kpi
                icon = {ca_svg_bleu}
                key={CGUID()}
                title={"File CA Bleu"}
                color={"purple"}
                text={"File CA Bleu"}
                value={"100"}
                unit={"%"}
                rotation={0}
                />}

              {globals.parameters.debugging_svg &&
              <Kpi
                icon = {chambre_svg_rose}
                key={CGUID()}
                title={"File ROOM ROSE"}
                color={"blue"}
                text={"File ROOM ROSE"}
                value={"100"}
                unit={"%"}
                rotation={180}
                />}

              {false &&
              <Kpi
                icon = {icon_svg_room}
                key={CGUID()}
                title={"Stream room"}
                color={"lavender"}
                text={"Stream room"}
                value={"100"}
                unit={"%"}
                rotation={180}
                />}

              {globals.parameters.debugging_svg &&
              <Kpi
                icon = {ca_svg_flatten}
                key={CGUID()}
                title={"ca-flatten-stream replaced room"}
                color={"green"}
                text={"ca-flatten-stream room"}
                value={"100"}
                unit={"%"}
                rotation={180}
                />}

              {globals.parameters.debugging_svg &&
              <Kpi
                icon = {icon_svg_room_flatten}
                key={CGUID()}
                title={"room-flatten-stream"}
                color={"orange"}
                text={"room-flatten-stream"}
                value={"80"}
                unit={"%"}
                rotation={180}
                />}
              
              {globals.parameters.debugging_svg &&
              <Kpi
                icon = {le_cercle_svg_stream}
                key={CGUID()}
                title={"lecercle_svg_stream"}
                color={"red"}
                text={"lecercle_svg_stream"}
                value={"100"}
                unit={"%"}
                rotation={0}
                />}

                {statsItems.map((statItem)=> {
                    return (
                      <Kpi
                        icon_style={statItem?.data_blob?.data_tier?.icon_style || ""}
                        key={statItem.data_guid}
                        title={statItem.data_blob.data_tier.stat_title}
                        color={statItem.data_blob.data_tier.stat_color}
                        text={statItem.data_blob.data_tier.stat_sub_title}
                        value={statItem.data_blob.data_tier.stat_value}
                        unit={statItem.data_blob.data_tier.stat_unit}
                        rotation={statItem.data_blob.data_tier.stat_rotation || 0}
                      />
                    )
                })}
                </div>

                <button
                    aria-label="scroll right"
                    className="kpi-arrow kpi-arrow-right"
                    onClick={() => { if (scrollRef.current) scrollRef.current.scrollBy({ left: 200, behavior: 'smooth' }); }}
                >
                    ›
                </button>
            </div>
            )
    }

    return(<>{kpiRendering()}</>)
} 

export default HomeLocalKPI;